export const useServiceType = () => {
  const isSravniDohod = __SERVICE_NAME__ === "sravni_dohod";
  const isKef = __SERVICE_NAME__ === "kef";

  return {
    isSravniDohod,
    isKef,
    serviceName: __SERVICE_NAME__,
  };
};
